import service from '@/api/configuration';
import {loading, handleError, storeLocal, getLocal} from '@/state/generators/helpers';

export const state = {
    loading: false,
    loadings: 0,
    title: '',
    alerts: [],
    listRefreshKey: 1,
    configuration: getLocal('configuration'),
    configurationService: service()
};
export const getters = {
    loading: function (state) {
        return !!state.loading;
    },
    alerts: function (state) {
        return JSON.parse(JSON.stringify(state.alerts));
    },
    configuration: function (state) {
        return state.configuration ? JSON.parse(JSON.stringify(state.configuration)) : null;
    },
    title: function (state) {
        return state.title;
    },
    listRefreshKey: function (state) {
        return Number(state.listRefreshKey);
    }
};
export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        if (boolean === true) {
            state.loadings += 1;
            state.loading = true;
        } else {
            if (state.loadings === 0) {
                state.loading = false;
            } else if (state.loadings > 0) {
                state.loadings -= 1;
                if (state.loadings === 0) {
                    state.loading = false;
                }
            }
        }
    },
    'SET_ALERTS': function (state, items) {
        state.alerts = items;
    },
    'SET_CONFIGURATION': function (state, configuration) {
        state.configuration = configuration;
        storeLocal('configuration', configuration);
    },
    'ADD_ALERT': function (state, alert) {
        if (!state.alerts) {
            state.alerts = [];
        }
        state.alerts.push(alert);
    },
    'REMOVE_ALERT' (state, index) {
        state.alerts.splice(index, 1);
    },
    'SET_TITLE': function (state, title) {
        state.title = title;
    },
    'INCREASE_LIST_REFRESH_KEY': function (state) {
        state.listRefreshKey += 1;
    },
};

export const actions = {
    title: function ({commit}, title) {
        commit('SET_TITLE', title)
    },

    configuration: function ({commit, rootGetters}) {
        if (!rootGetters['user/authenticated']?.id) {
            return;
        }

        loading(commit, true);

        return state.configurationService.fetchConfiguration().then(response => {
            commit('SET_CONFIGURATION', response.data);
            loading(commit, false)
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    setConfiguration({commit}, payload = null) {
        commit('SET_CONFIGURATION', payload);
    },

    addAlert: function ({commit}, payload) {
        commit('ADD_ALERT', payload);
    },

    refreshList: function ({commit}) {
        commit('INCREASE_LIST_REFRESH_KEY');
    },
};
